import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/views/app/Index'),
      redirect: '/channels',

      children: [
        {
          path: '/channels',
          component: () => import('@/views/app/pages/Pages'),
          children: [
            {
              name: 'ChannelsPage',
              path: '',
              component: () => import('@/views/app/pages/Channels'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':channel_id',
              name: 'Channel',
              component: () => import('@/views/app/pages/ChannelDetails'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/ads',
          component: () => import('@/views/app/pages/Pages'),
          children: [
            {
              name: 'AdsPage',
              path: '',
              component: () => import('@/views/app/pages/Ads'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/third-party-channels',
          component: () => import('@/views/app/pages/Pages'),
          children: [
            {
              name: 'ThirdPartyChannelsPage',
              path: '',
              component: () => import('@/views/app/pages/ThirdPartyChannels'),
              meta: { onlyAuthUser: true },
            },
            {
              path: 'new',
              name: 'NewThirdPartyChannel',
              component: () => import('@/views/app/pages/ThirdPartyChannelNew'),
              meta: { onlyAuthUser: true },
            },
            {
              path: 'batch-edit',
              name: 'ThirdPartyChannelBatchEdit',
              component: () => import('@/views/app/pages/ThirdPartyChannelBatchEdit'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':channel_id',
              name: 'ThirdPartyChannel',
              component: () => import('@/views/app/pages/ThirdChannelDetails'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/distributions',
          component: () => import('@/views/app/distribution/Route'),
          children: [
            {
              path: '/',
              name: 'Distributions',
              component: () => import('@/views/app/distribution/List'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':distribution_id',
              name: 'Distribution',
              component: () => import('@/views/app/distribution/Details'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':distribution_id/edit',
              name: 'EditDistribution',
              component: () => import('@/views/app/distribution/Edit'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':distribution_id/edit-meta',
              name: 'EditDistributionMeta',
              component: () => import('@/views/app/distribution/EditMeta'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/templates',
          component: () => import('@/views/app/templates/Pages'),
          children: [
            {
              name: 'Templates',
              path: '',
              component: () => import('@/views/app/templates/List'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':template_id',
              name: 'Template',
              component: () => import('@/views/app/templates/Template'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
        {
          path: '/sotalcloud-instances',
          component: () => import('@/views/app/sotalcloud/Route'),
          children: [
            {
              name: 'SotalCloudOperators',
              path: '',
              component: () => import('@/views/app/sotalcloud/List'),
              meta: { onlyAuthUser: true },
            },
            {
              path: ':operator_id',
              name: 'SotalCloudOperator',
              component: () => import('@/views/app/sotalcloud/Operator'),
              meta: { onlyAuthUser: true },
            },
          ],
        },
      ],
    },
    {
      path: '/signin',
      component: () => import('@/views/app/sessions/Sessions'),
      children: [
        {
          name: 'SignIn',
          path: '',
          component: () => import('@/views/app/sessions/SignIn'),
          meta: { onlyGuestUser: true },
        },
      ],
    },
    {
      path: '*',
      redirect: '/channels',
    },
  ],
})

router.beforeEach((to, from, next) => {
  router.prevRoute = from
  store.dispatch('tryAutoLogin')
    .then(() => {
      const { isAuthenticated } = store.getters

      if (isAuthenticated && to.meta.onlyGuestUser) {
        next({ path: '/' })
      } else if (!isAuthenticated && to.meta.onlyAuthUser) {
        next({ name: 'SignIn' })
      } else {
        next()
      }
    })
    .catch(() => {
      next({ name: 'SignIn' })
    })
})

export default router
